export const appBaseURL = "/"

export const appLayoutTransition = {"name":"layout","mode":"out-in"}

export const appHead = {"meta":[{"http-equiv":"Content-Type","content":"text/html; charset=utf-8"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=2.0"},{"id":"description","name":"description","content":"Welcome to Portfolio Rottigni, let's discover something about Lorenzo Rottigni, his journey and his work!"},{"name":"format-detection","content":"telephone=no"},{"name":"referrer","content":"origin-when-cross-origin"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"application-name","content":"Portfolio Rottigni"},{"name":"apple-mobile-web-app-title","content":"Portfolio Rottigni"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"msapplication-starturl","content":"/"},{"property":"og:type","content":"website"},{"property":"og:title","content":"Portfolio Rottigni"},{"property":"og:description","content":"Welcome to Portfolio Rottigni, let's discover something about Lorenzo Rottigni, his journey and his work!"},{"property":"og:url","content":"https://portfolio.rottigni.tech/"},{"property":"og:site_name","content":"Portfolio Rottigni"},{"property":"og:image","content":"https://s3.rottigni.tech/portfolio.rottigni.tech/static/images/logo/LR_labs/LR_labs_logo.png"},{"property":"og:image:secure_url","content":"https://s3.rottigni.tech/portfolio.rottigni.tech/static/images/logo/LR_labs/LR_labs_logo.png"},{"property":"og:image:width","content":"500"},{"property":"og:image:height","content":"500"},{"name":"twitter:site","content":"@LorenzoRottigni"},{"name":"twitter:card","content":"summary"},{"name":"twitter:description","content":"Welcome to Portfolio Rottigni, let's discover something about Lorenzo Rottigni, his journey and his work!"},{"name":"twitter:title","content":"Portfolio Rottigni"},{"name":"mobile-web-app-capable","content":"yes","key":"mobile-web-app-capable"},{"name":"apple-mobile-web-app-title","content":"root-workspace-0b6124","key":"apple-mobile-web-app-title"},{"property":"og:type","content":"website","key":"og:type"},{"property":"og:title","content":"root-workspace-0b6124","key":"og:title"},{"property":"og:site_name","content":"root-workspace-0b6124","key":"og:site_name"},{"name":"twitter:card","content":"summary","key":"twitter:card"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"shortcut icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/android-chrome/android-chrome-192x192.png"},{"rel":"icon","type":"image/png","sizes":"512x512","href":"/android-chrome/android-chrome-512x512.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"icon","href":"/_nuxt/icons/64x64.17fd8b83.png","key":"favicon"},{"rel":"apple-touch-icon","href":"/_nuxt/icons/512x512.maskable.17fd8b83.png","sizes":"512x512","key":"favicon-apple"},{"rel":"manifest","href":"/manifest.json"}],"style":[],"script":[],"noscript":[{"innerHTML":"Javascript is required"}],"charset":"utf-8","title":"root-workspace-0b6124","htmlAttrs":{"lang":"en"}}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = false

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true